import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import {
  FirebaseAnalyticsService,
  FirebaseService,
  MicroCoreUtilityModule,
  MicroUtilTranslationService,
} from '@micro-core/utility';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

const ROUTES: Routes = [
  {
    path: 'digital-card-details',
    loadChildren: () => import('@brightside-web/micro/digital-card-details').then((m) => m.MicroDigitalCardDetailsModule),
  },
  {
    path: 'student-loans/savi',
    loadComponent: () => import('@brightside-web/micro/entry').then((c) => c.SaviInfoComponent)
  },
  {
    path: 'student-loans',
    loadComponent: () => import('@brightside-web/micro/entry').then((c) => c.SaviSplashComponent)
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(ROUTES), MicroCoreUtilityModule, TranslateModule],
  providers: [
    { provide: FirebaseService, useClass: FirebaseAnalyticsService },
    { provide: TranslateService, useClass: MicroUtilTranslationService },
  ],
})
export class MicroEntryModule {}
